import { CustomerSecurityMaster } from '@src/containers/Dealer/CustomerSecurityMaster/CustomerSecurityMaster';
import type { CustomerSecurityMasterPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerSecurityMasterPanel({ api, params }: LayoutPanelProps<CustomerSecurityMasterPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-security-master-panel"
    >
      <CustomerSecurityMaster />
    </EntityAdminPanelShell>
  );
}
